import React from 'react';

import { Chip, ChipProps } from '@mui/material';

import isProd from '~/utils/isProd';
import { titleCase } from '~/utils/stringUtils';

// TODO: Remove isProd() guard and legacy status mapping once Phase 5 DB migration is complete (LEBT-2153).
export function getDisplayStatus(status: string): string {
  if (!status) {
    return '';
  }
  if (status === 'AVAILABLE') {
    return 'Available';
  }
  if (status === 'PENDING') {
    return isProd() ? 'Pending invite' : 'Available';
  }
  if (status === 'EXPIRED') {
    return isProd() ? 'Expired' : 'Available';
  }
  return titleCase(status);
}

const STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  Available: 'warning',
  'Pending invite': 'warning',
  Activated: 'success',
};

function getStatusColor(displayStatus: string): ChipProps['color'] {
  return STATUS_COLOR_MAP[displayStatus] ?? 'error';
}

export default function EmployeeStatusCell({ status }: { status: string }) {
  const displayStatus = getDisplayStatus(status);
  if (!displayStatus) {
    return null;
  }
  return <Chip label={displayStatus} color={getStatusColor(displayStatus)} />;
}
